const scenarios = [
  {
    tag: 'Travel',
    title: 'Never Miss a Session — Anywhere on Earth',
    description: 'From Indo boat trips to Irish cold-water slabs, PHIX Doctor kits are in surf bags worldwide. TSA-approved Micro Kits fit in any carry-on. Reef crack in Morocco? Fixed before the next set.',
    image: 'https://public.readdy.ai/ai/img_res/cdf34ebe80818ff5cd7f8cb7afaa0064.jpg',
  },
  {
    tag: 'Beach',
    title: 'Quick Fixes Between Sets',
    description: 'Ding between surfs? Pull your kit out, apply, cure in the next two minutes of sun, sand smooth, and paddle back out. The session doesn\'t have to end.',
    image: 'https://readdy.ai/api/search-image?query=surfer%20kneeling%20on%20sunny%20beach%20applying%20repair%20resin%20to%20surfboard%20ding%20kit%20laid%20out%20sand%20tropical%20beach%20lifestyle%20photography&width=700&height=480&seq=pg2&orientation=landscape',
  },
];

export default function ProductsGlobal() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Global & Local Use</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900">
            The Kit That Goes<br />
            <span className="text-[#0B5C4D]">Everywhere You Surf</span>
          </h2>
        </div>

        <div className="space-y-0">
          {scenarios.map((s, idx) => (
            <div
              key={s.title}
              className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center border-b border-stone-100 last:border-0`}
            >
              <div className="w-full lg:w-[55%] h-72 lg:h-80 overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="w-full lg:w-[45%] p-10 lg:p-14">
                <span className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4">{s.tag}</span>
                <h3 className="text-stone-900 font-black text-2xl mb-3">{s.title}</h3>
                <p className="text-stone-500 text-base leading-relaxed">{s.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Global stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-14">
          {[['60+', 'Countries'], ['1,200+', 'Retail Stores'], ['40K+', 'Surfers'], ['4.9★', 'Rating']].map(([v, l]) => (
            <div key={l} className="bg-[#F5EFE6] rounded-2xl p-6 text-center">
              <p className="text-[#0B5C4D] font-black text-3xl mb-1">{v}</p>
              <p className="text-stone-500 text-sm uppercase tracking-wider">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
